module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a1cb4"))).then(() => module.bundle.root('d0iPb'));